<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Kontrole {{shema}}</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
              <pridelovalec :pridelovalec="pridelovalec" shema="IP" :sezona="dataSezona.sezona">
          </pridelovalec>
            
          </div>
        </div>
    
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <Grid  
                       
                      
                        :data-items="gridData"
                        :columns="columns"
                    
                       
                       :edit-field="'inEdit'"
                        @itemchange="itemChange"

                        
                         :row-render="rowRenderFunction"
                      
                        

                         
                        
                                               >
                 <template v-slot:ukaznigumbi="{props}">
                  <ukaznigumbiknt :data-item="props.dataItem"   :editDisabled="editDisabled"
                    @edit="edit"
                    @save="saveItem" 
                    @remove="removeItem"
                    @cancel="cancel"/>

                    </template>
                <template v-slot:vrstakontrole="{props}">
                      <ddcell :data-item="props.dataItem" 
                        :field="props.field"

                        :sifrantData="sifrant['vrstakontroleip']"
                        :selectedValue="{naziv:props.dataItem.vrstakontrole,id:sifrant['vrstakontroleip'].find(i=>i.naziv==props.dataItem.vrstakontrole).id}"
                        @change="(e) => sifrantVrstaChange(e, props.dataItem)"
                   />
                    </template>

                    <template v-slot:statusnadzora="{props}">
                      <ddcell :data-item="props.dataItem" 
                        :field="props.field"

                        :sifrantData="sifrant['statusnadzora']"
                        :selectedValue="{naziv:props.dataItem.status,id:sifrant['statusnadzora'].find(i=>i.naziv==props.dataItem.status).id}"
                        @change="(e) => sifrantStatusChange(e, props.dataItem)"
                   />
                    </template>

                    <template v-slot:podrocje="{props}">
                      <ddcell :data-item="props.dataItem" 
                        :field="props.field"

                        :sifrantData="sifrant['podrocjaip']"
                        :selectedValue="{naziv:props.dataItem.podrocjecertificiranja,id:sifrant['podrocjaip'].find(i=>i.naziv==props.dataItem.podrocjecertificiranja).id}"
                        @change="(e) => sifrantPodrocjeChange(e, props.dataItem)"
                   />
                    </template>
           
                <template v-slot:uredi="{props}">
                  <td><kbutton theme-color="primary" @click="uredikontrolo(props.dataItem)" ><font-awesome-icon :icon="'list-check'"/> </kbutton>
                        
                      </td>
                    </template>

                    


 
                    
                    <template v-slot:kontrolor="{props}">

                      <ddcell :data-item="props.dataItem" 
                        :field="props.field"

                        :sifrantData="sifrant['kontrolorjiip']"
                        :selectedValue="{naziv:props.dataItem.kontrolornaziv,sifra:sifrant['kontrolorjiip'].find(i=>i.naziv==props.dataItem.kontrolornaziv).sifra}"
                        @change="(e) => kontrolorChange(e, props.dataItem)"
                   />


                    </template>

                                    
                   
                   
                 
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                       
                        <button title="Dodaj" :disabled="editDisabled"
                                class="k-button k-primary"
                                @click="vstavi">
                                Dodaj kontrolo
                        </button>
                      
                        
                        <!--
                             <button :disabled="editDisabled"
                                title="Prenesi iz prejšnje sezone"
                                class="k-button k-primary"
                               @click="dodajIzPrejsnjeSezone"
                            >
                                Prenesi iz prejšnje sezone
                            </button>
                          -->
                             <button :disabled="editDisabled"
                                title="Shrani kontrole"
                                class="k-button k-primary"
                                @click="shraniKontrole"
                            >
                                Shrani
                            </button>

                                  <button class="k-button k-primary"  title="Nazaj" @click="nazaj" >Nazaj</button>
                       </div>
                            
                        </toolbar>
                         <GridNoRecords >
                    <div v-if="dataLoading" class="k-loading-mask loadingIconSpace">
                      <span class='k-loading-text'></span>
                      <div class='k-loading-image'></div>
                      <div class='k-loading-color'></div>
                      
                    </div>
                    <div v-else>
                      Ni podatkov!
                    </div>
                    </GridNoRecords>
                    </Grid>

                    </div>
    </div>

</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DropDownList,ComboBox } from '@progress/kendo-vue-dropdowns';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
//import SifrantKontrolaDownCell from './support/SifrantKontrolaDropDown';
import PridelovalecKratko from './support/PridelovalecKratko';
import { process } from '@progress/kendo-data-query';
import moment from 'moment'
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';


/*
Samo določeni uporabniki imajo pravico dodati in izbrisati kontrolo...

*/


export default {
  components:{
    
    'kbutton':Button,
      'ukaznigumbiknt': StatusCommandCell,
      'ddcell': StatusDownCell,
      'combobox': ComboBox,
      'dropdownlist': DropDownList,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
      'pridelovalec':PridelovalecKratko
  },
  props:['sezona','pridelovalecid','shema'],
    data () {
        return {
            
            sifrantTree:{},
            dataLoading:false,
           statusnadzora:[
			{id:1,naziv:"nova"},
			{id:2,naziv:"v teku"},
			{id:3,naziv:"odločitev"},
			{id:4,naziv:"konec"},
      {id:5,naziv:"Prekoračen rok, neskladja niso odpravljena"},
		   ],
            dataSezona:this.sezona,
          
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' } 
            ],
            columns: [

               { field: "zaporednastevilka", title:"ID",width: "100px",filterable:false,footerCell:this.nogaNazivVsot,type:"number",editable:false,width: "50px"},
               { cell: "uredi", title:"Status nazdora",width: "70px"},
			   { field: "statusnadzora", cell:"statusnadzora",title:"Status nazdora",width: "150px"},
			   //{ field: "shema", title:"shema"},
			   { field: "podrocjecertificiranja", cell:"podrocje", title:"podrocje",width: "140px"},
			   //{ field: "izvajalec", title:"izvajalec"},
			   //{ field: "naslov", title:"naslov"},
			   { field: "datumkontrole", filterable:false, title:"Datum kontrole",width: "150px", type:"date",editor:"date",format:"{0:d}"},
               { field: "trajanje", title:"Trajanje (h)",width: "80px",filterable:false,type:"number",editor:"numeric",format:"{0:n2}"},
            
			   { field: "vrstakontrole", cell:"vrstakontrole", title:"Vrsta kontrole",width: "220px"},
			   { field: "kontrolornaziv", cell:"kontrolor", title:"Kontrolor",width: "240px"},
         { field: "rokizvedbe", filterable:false, title:"Rok izvedbe",width: "150px", type:"date",editor:"date",format:"{0:d}"},
               { field: "mnenjekontrolorja", title:"Mnenje",width: "90px"},
             
			   { field: "tveganje", title:"Ocena tveganja"},
			   { field: "cena", title:"cena"},
			   { field: "statusplacila", title:"Status plačila"},
			 
            { cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
            ],
          

           

        }
    },
      computed: {
        editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },

        ...mapState({gridData(state) {
          return state.kontrola.kontrola;
        }}),

        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
            },
    created () {

      this.naloziPodatke(this.shema,this.sezona);

      
    },
    beforeRouteUpdate (to, from,next) {
    
    this.naloziPodatke(to.query.title,to.query.sezona,next);

},
  


    methods: {
      uredikontrolo(kontrola){
            
            var shema=this.$route.query.title;
            var sezona=this.$route.query.sezona;
            var pridelovalecid=kontrola.pridelovalecid;
            var kontrolaid=kontrola._id;

            

            this.$router.push({ name: 'kontrolaip', params: { sezona:sezona,shema:shema,pridelovalecid:pridelovalecid,kontrolaid:kontrolaid} })
            

        },
      ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),
        ...mapActions('kontrola', ['load','save','loadPreteklaSezona']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('kontrola',['update',"add","remove","makeEditable",'replace']),
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jeaktivna!=1)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
             nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Vsota:']);
        },
        //gvž in število
        nogaVsotaStevila: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.stevilo?current.stevilo:0):0, 0),"n0")]);
        },
        nogaVsotaGvz: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.vsotagvz?current.vsotagvz:0):0, 0),"n3")]);
        },
              formatDate: function (h, emptyElement , props, listeners ) {
            if(props.dataItem.inEdit)
              return emptyElement
            else
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
            //error handle za prazen šifrnat!!!!
        naloziPodatke: function(shema,sezona,next){

          if(!sezona)
            this.dataSezona={sezona:this.$trenutnasezona};
          else
            this.dataSezona={sezona:parseInt(sezona)};

          this.dataLoading=true;

        this.replace([]);
        //.then(()=>{
        var pdata=[
        this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}),
        this.naloziSifrant({sezona:sezona,sifrant:"vrstakontroleip"}),
        this.naloziSifrant({sezona:sezona,sifrant:"kontrolorjiip"}),
        this.naloziSifrant({sezona:sezona,sifrant:"statusnadzora"}),
        this.naloziSifrant({sezona:sezona,sifrant:"podrocjaip"})]
        
        Promise.all(pdata).then(()=>{

           this.load({sezona:sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,shema:shema}).then(

          data=>{this.dataLoading=false;
          
            if(next)
                next();
          },



          error=>{console.log("tukaj sem!!!");this.dataLoading=false;});
        });
     

       
      
        },
        sifrantVrstaChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["vrstakontroleid"])
              dataItem.oldValues["vrstakontroleid"] =dataItem["vrstakontroleid"];

            if(!dataItem.oldValues["vrstakontrole"])
              dataItem.oldValues["vrstakontrole"] =dataItem["vrstakontrole"];



            Vue.set( dataItem, 'vrstakontrole',e.value.naziv);
              Vue.set( dataItem, 'vrstakontroleid',e.value.id);
            
    
        },
        sifrantStatusChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


           
            if(!dataItem.oldValues["status"])
              dataItem.oldValues["status"] =dataItem["status"];



      
              Vue.set( dataItem, 'status',e.value.naziv);
            
    
        },
        sifrantPodrocjeChange: function(e,dataItem) {
            if(!dataItem.oldValues)
            dataItem.oldValues={}
            if(!dataItem.oldValues["podrocjecertificiranja"])
            dataItem.oldValues["podrocjecertificiranja"] =dataItem["podrocjecertificiranja"];
            Vue.set( dataItem, 'podrocjecertificiranja',e.value.naziv);
},
          

        kontrolorChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["kontrolornaziv"])
              dataItem.oldValues["kontrolornaziv"] =dataItem["kontrolornaziv"];

         
            Vue.set( dataItem, 'kontrolornaziv',e.value.naziv);
            Vue.set( dataItem, 'kontrolor',e.value.sifra);
            
         
    
        },
        itemChange: function (e) {
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          Vue.set( e.dataItem, e.field,e.value);

        //  if(e.field=="stevilo")
          //    Vue.set( e.dataItem, 'vsotagvz',(e.value?e.value:0)*this.sifrant['proizvod'].find(s=>s.id==e.dataItem.proizvodid).gvz);              
           
        },
        dodajIzPrejsnjeSezone(){
            this.loadPreteklaSezona({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled});

        },

        //default vrednosti
         vstavi() {
            const dataItem = { inEdit: true,jeaktivna:1,
                  zaporednastevilka:this.gridData.reduce((a,c)=>{return c.zaporednastevilka>a?c.zaporednastevilka:a},0)+1,
                  datumkontrole:new Date(),
                  vrstakontroleid:this.sifrant["vrstakontroleip"][0].id,
                  vrstakontrole:this.sifrant["vrstakontroleip"][0].naziv,
                  status:this.sifrant["statusnadzora"][0].naziv,
                  kontrolornaziv:this.sifrant["kontrolorjiip"][0].naziv,
                  kontrolor:this.sifrant["kontrolorjiip"][0].sifra,
                  podrocjecertificiranja:this.sifrant["podrocjaip"][0].naziv,
                  rokizvedbe:new Date(),
                  
                   };
            this.add(dataItem);
        },
        edit: function (e) {
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = 1;
            
            this.update(e.dataItem);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
               Vue.set( dataItem, value,dataItem.oldValues[value]);
            }
             Vue.set( dataItem, jeaktivna,0);
             Vue.set( dataItem, jeaktivna,1);
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = 1;
            this.update(e.dataItem);
        },
        removeItem(e) {
            e.dataItem.inEdit =!e.dataItem.inEdit;
            e.dataItem.jeaktivna=e.dataItem.jeaktivna?0:1;
            this.update(e.dataItem);

        },
        //tu je treba dodat še shemo...
       sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              //this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'kontrola', params: {sezona:sezona.sezona,pridelovalecid:this.pridelovalec._id} });
             this.pridelovalec.sezona=this.sezona;
             this.naloziPodatke();
             // });



        },
/*
             @datastatechange="dataStateChange"
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
            this.dataResult = process(this.gerk, {});

        },
  */    
        shraniKontrole () {
              this.save();
    },
       
        
    }
};
</script>

